var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { SvgIcon } from '../svg-icon';
export var IdTagIcon = function (_a) {
    var _b = _a.color, color = _b === void 0 ? 'currentColor' : _b, rootProps = __rest(_a, ["color"]);
    return (React.createElement(SvgIcon, __assign({ viewBox: "0 0 18 18", fill: "none" }, rootProps),
        React.createElement("path", { d: "M2.6 4H15.4C16.28 4 17 4.675 17 5.5V14.5C17 15.325 16.28 16 15.4 16H2.6C1.72 16 1 15.325 1 14.5V5.5C1 4.675 1.72 4 2.6 4Z", stroke: color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("line", { x1: "11.25", y1: "7.75", x2: "13.75", y2: "7.75", stroke: color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("line", { x1: "11.25", y1: "10.25", x2: "13.75", y2: "10.25", stroke: color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M9.33333 13.5V13.3333C9.33333 12.9797 9.19286 12.6406 8.94281 12.3905C8.69276 12.1405 8.35362 12 8 12H5.33333C4.97971 12 4.64057 12.1405 4.39052 12.3905C4.14048 12.6406 4 12.9797 4 13.3333V13.5", stroke: color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M6.66666 9.66667C7.40304 9.66667 7.99999 9.06971 7.99999 8.33333C7.99999 7.59695 7.40304 7 6.66666 7C5.93028 7 5.33333 7.59695 5.33333 8.33333C5.33333 9.06971 5.93028 9.66667 6.66666 9.66667Z", stroke: color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M10.5 1.88889C10.5 1.65314 10.421 1.42705 10.2803 1.26035C10.1397 1.09365 9.94891 1 9.75 1H8.25C8.05109 1 7.86032 1.09365 7.71967 1.26035C7.57902 1.42705 7.5 1.65314 7.5 1.88889", stroke: color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })));
};
